import ApiService from './ApiService'

export async function apiReportError(data) {
    return ApiService.fetchData({
        url: '/report-error',
        method: 'post',
        data,
    })
}
